module.exports = __webpack_public_path__ + "img/paper_1x.35186e9a.png";